module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.5e1aec0.woff";